import { Category } from "@faire/deprecated-retailer-visitor-shared/models/Category/Category";
import { useGetSuppliersBreadcrumbOptions } from "@faire/deprecated-retailer-visitor-shared/views/suppliers/__internal__/LazySuppliersPage/__internal__/SuppliersPage/__internal__/LoggedOutSuppliersPage/__internal__/Components/LoggedOutSuppliersPageHeader/__internal__/LoggedOutSuppliersPageBreadcrumb/__internal__/useGetSuppliersBreadcrumbOptions";
import { Core } from "@faire/design-tokens";
import { useStrictLocalization } from "@faire/web/common/localization";
import { Row } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { Link } from "@faire/web/ui/LinkAnchor";
import * as React from "react";

export const LoggedOutSuppliersPageBreadcrumb: React.FC<{
  category: Category;
}> = ({ category }) => {
  const { strictLocalize } = useStrictLocalization();
  const { breadCrumbOptions } = useGetSuppliersBreadcrumbOptions(
    category,
    strictLocalize
  );
  return (
    <Row
      align="center"
      data-test-id="logged-out-breadcrumb"
      role="navigation"
      aria-label={strictLocalize({
        id: "2ezgqJ",
        defaultMessage: "Breadcrumbs",
        description: {
          text: "Label of the breadcrumbs for navigation",
        },
      })}
    >
      {breadCrumbOptions.map((option, index) => {
        return (
          <React.Fragment key={option.label}>
            {!option.path ? (
              <Typography color={Core.text.subdued}>{option.label}</Typography>
            ) : (
              <Link to={option.path ?? ""}>
                <Typography color={Core.text.default}>
                  {option.label}
                </Typography>
              </Link>
            )}
            {index !== breadCrumbOptions.length - 1 ? (
              <>
                <Spacer width="1x" />
                <Typography color={Core.text.subdued}>/</Typography>
                <Spacer width="1x" />
              </>
            ) : null}
          </React.Fragment>
        );
      })}
    </Row>
  );
};
